import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	RADIO_ITEM: '[name="frm.position"]',
};

class CVPositionComponent extends WebComponent {

	didMount() {
		this.on('click',fragments.BUTTON, this.handleClickButton);
		this.radioButtonElement = this.element.querySelectorAll(fragments.RADIO_ITEM);
		var urlParams = new URLSearchParams(window.location.search);
		var positionId  = urlParams.get('position');
		for(var i = 0; i < this.radioButtonElement.length; i++) {
			 if(this.radioButtonElement[i].value === positionId) {
			 	this.radioButtonElement[i].click();
			 }
		}
	}

	willUnMount() {
		this.radioButtonElement = null;
	}

}

export default CVPositionComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/CVPositionComponent/CVPositionComponent.js